/*引入axios*/
import axios from 'axios'
const request = axios.create({
  // baseURL: 'http://localhost/career_m/', // 本地
  baseURL: 'https://stg-career.gehealthcare.cn/career_m/', // stg 基础路径,将统一的部分全部封装
  // baseURL: 'https://career.gehealthcare.cn/career_m/', // pord 生产 基础路径,将统一的部分全部封装
  // baseURL : "https://stg-career.gehealthcare.cn/career_m",
  withCredentials: true // 表示请求可以携带cookie
})
//前端采用export.default，在写后端代码时用module.export
export default request



// WEBPACK FOOTER //
// ./src/utils/request.js